import { c as _c } from "react/compiler-runtime";
import { WeekdaysBackendEnum } from '../types/availability-interface';
export function AvailabilitySlotsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col">{Object.values(WeekdaysBackendEnum).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(weekday) {
  return <div key={weekday} className="border-text-secondary/50 [&>div]:h-7 grid grid-cols-3 gap-4 border-t py-5 md:grid-cols-4"><div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div><div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div><div className="bg-skeleton-primary animate-pulse rounded-sm text-transparent">.</div><div className="bg-skeleton-primary hidden animate-pulse rounded-sm text-transparent md:block">.</div></div>;
}